// An advanced target's value for a bucket it doesn't set: the nearest earlier
// bucket's, else the next one's, else 100
export const getPredictedKpiTarget = (
  advancedTarget: GoalAdvancedTarget,
  date: string,
) => {
  const tmpT = {
    ...advancedTarget,
    [date]: 0,
  };
  const allKeys = Object.keys(tmpT).sort();
  const thisKeyIndex = allKeys.findIndex((currentKey) => currentKey === date);

  if (thisKeyIndex === 0) {
    if (allKeys.length > 1) {
      const nextValueKey = allKeys[thisKeyIndex + 1];
      const v = tmpT[nextValueKey];

      if (v) {
        return v;
      }
    }
  } else {
    const previousValueKey = allKeys[thisKeyIndex - 1];
    const v = tmpT[previousValueKey];

    if (v) {
      return v;
    }
  }

  return 100;
};

// For use in the vis
const getKpiTargetForMonth = (
  advancedTarget: GoalAdvancedTarget,
  date: string,
) => {
  if (advancedTarget[date] !== undefined) {
    return advancedTarget[date] as number;
  }

  return getPredictedKpiTarget(advancedTarget, date);
};

export default getKpiTargetForMonth;
